<template>
  <div class="box">
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
      <el-table-column label="收入方式" min-width="120">
        <template >
          <div>
            <el-form-item label="" prop="incomePattern" class="table_error" >
              <el-select  v-model="goodform.incomePattern" filterable placeholder="请选择">
                <el-option v-for="item in SRFSlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否开票" min-width="120">
        <template >
          <div>
            <el-form-item label=""   class="table_error" >
              <el-select  v-model="goodform.makeTicketYn" filterable placeholder="请选择" >
                <el-option  label="是" value="是" ></el-option>
                <el-option  label="否" value="否" ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
        <el-table-column label="是否一票制" min-width="120">
        <template >
          <div>
            <el-form-item label=""    class="table_error" >
              <el-select  v-model="goodform.ticketSystemYn" filterable placeholder="请选择">
                <el-option  label="是" value="是" ></el-option>
                <el-option  label="否" value="否" ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入计价" min-width="120">
        <template >
          <div>
            <el-form-item label=""    class="table_error" >
              <el-select  v-model="goodform.revenueValuation"  placeholder="请选择" @change="jijiaChange">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入单价(元)" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>收入单价(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""   class="table_error" prop="incomeUnitPrice" v-if="goodform.revenueValuation!=1">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.incomeUnitPrice"  ></el-input>
            </el-form-item>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入金额(元)" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>收入金额(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error"  prop="incomeAmount">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.incomeAmount"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入税率" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>收入税率%</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="taxRate" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="12" v-model="goodform.taxRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDictionaryDetailList, getPrice, getPriceCustomerForVehicleLength } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
export default {
  name: 'shouru',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      SRFSlist: [],
      SRJJlist: [],
      isInitialized: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetailList({ dictionaryType: 'up_settlement_type' }).then(res => {
      this.SRFSlist = res
      if (!this.goodform.incomePatternName && this.goodform.incomePattern) {
        let json = this.SRFSlist.filter(item => item.itemNo == this.goodform.incomePattern)
        this.goodform.incomePatternName = json[0].showName
      }
    })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => {
      this.SRJJlist = res
      if (!this.goodform.revenueValuationName && this.goodform.revenueValuation) {
        let json = this.SRJJlist.filter(item => item.itemNo == this.goodform.revenueValuation)
        this.goodform.revenueValuationName = json[0].showName
      }
    })
    setTimeout(() => {
      this.isInitialized = true
    }, 3000)
  },
  methods: {
    // 收入方式更改
    SRFSchange (e) {
      let json = this.SRFSlist.filter(item => item.itemNo == e)
      this.goodform.incomePatternName = json[0].showName
    },
    // 收入计价更改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.revenueValuationName = json[0].showName
      if (this.goodform.revenueValuation == 1) {
        this.$set(this.goodform, 'incomeUnitPrice', '')
        this.$set(this.goodform, 'incomeAmount', '')
      } else {
        this.$set(this.goodform, 'incomeUnitPrice', '')
        this.$set(this.goodform, 'incomeAmount', '')
      }
    },
    // 货物客户价格
    getkehuPriceFn () {
      if (this.goodform.payee == '首钢京唐钢铁联合有限责任公司') { // 首钢价格
        if (this.goodform.revenueValuation == 1) {
          this.$set(this.goodform, 'incomeUnitPrice', '')
        } else {
          if (this.goodform.productTypeName == '冷卷' || this.goodform.productTypeName == '热卷' || this.goodform.productTypeName == '中厚板' || this.goodform.productTypeName == '剪切板') {
            getPrice({
              productType: (this.goodform.productTypeName == '中厚板' || this.goodform.productTypeName == '剪切板') ? 3 : this.goodform.productTypeName == '冷卷' ? 1 : 2, // 1. 冷卷 ，2 热卷，3. 中厚板
              keyWords: this.goodform.endDirection.replace(/-/g, '') + this.goodform.receivingAddress
            }).then(res => {
              this.$set(this.goodform, 'incomeUnitPrice', res)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
            })
          }
        }
      } else {
        let chechang = this.goodform.needLength ? this.goodform.needLength : '全部'
        if (this.goodform.payee && this.goodform.productTypeName && this.goodform.startDirection && this.goodform.endDirection &&
      chechang && this.goodform.revenueValuationName) {
          getPriceCustomerForVehicleLength({
            payee: this.goodform.payee,
            productTypeName: this.goodform.productTypeName,
            startDirection: this.goodform.startDirection,
            endDirection: this.goodform.endDirection,
            vehicleLength: chechang,
            revenueValuationName: this.goodform.revenueValuationName,
            arriveDepartFlag: this.goodform.arriveDepartFlag
          }).then(res => {
            if (res.price) {
              if (this.goodform.revenueValuation == 1) { // 包干
                this.$set(this.goodform, 'incomeAmount', res.price)
                this.$set(this.goodform, 'incomeUnitPrice', '')
              } else {
                this.$set(this.goodform, 'incomeUnitPrice', res.price)
                this.$set(this.goodform, 'incomeAmount', '')
              }
            }
          })
        }
      }
    }
  },
  computed: {
    kehuPricChange () {
      const { productType, payee, startDirection, endDirection, needLength, revenueValuation, arriveDepartFlag } = this.goodform
      return { productType, payee, startDirection, endDirection, needLength, revenueValuation, arriveDepartFlag }
    }
  },
  watch: {
    kehuPricChange: {
      handler (newVal, oldVal) {
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          if (this.isInitialized) {
            this.getkehuPriceFn()
          }
        }
      }
    },
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.orderWeight && this.goodform.incomeUnitPrice) {
          let n = toFixed(accMul(this.goodform.orderWeight, this.goodform.incomeUnitPrice), 2)
          this.$set(this.goodform, 'incomeAmount', n)
        }
        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.tableBox{
  width:1000px;
  margin-left:12px
}
.box /deep/.el-input__inner{
  width: 120px;
}
</style>
